//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'mt-dropdown-menus',
    data () {
        return {
          itemWidth:'',
          shadowTop:''
        }
    },
    props:{
        options:{type:Array,default:[]},
        isShowMenu: {
            type: Boolean,
            default: false
        }
    },

    watch:{
      options:function(n){
        if(n.length){
          this.itemWidth = (100 / n.length) + '%';
        }else {
          console.log('按钮组长度为0')
        }
      },
      isShowMenu: function(n){
        if(n){
          this.$nextTick(function(){
            this.shadowTop = this.$refs.menu.offsetTop+"px";
          })
        }else{
          document.body.style.overflow = "auto";
        }
      }
    },

    components:{
        
    },
    created() {
        if(this.options.length){
          this.itemWidth = (100 / this.options.length) + '%';
        }
    },
    methods:{
        setSelected:function(param,index,evt){
            var that = this;
            that.$nextTick(function () {
                that.options.forEach(function (item) {
                that.$set(item,'active',false);
              });
              that.$set(param,'active',true);
              that.$set(param,'index',index);
              that.$emit('dropDown',param,evt);
            });
            document.body.style.overflow = "hidden";
        },
        cancelShadow: function(evt) {
          this.options.forEach(function(ele) {
            if (ele.active) {
              ele.active = false;
            }
          });
          this.borderActive=false;
          //this.isShowMenu = false;
          this.$emit('cancel', evt);
        }
    }
}



// WEBPACK FOOTER //
// ./packages/dropdown-menus/src/dropdown-menus.vue